import { useEffect, useState, useCallback, useRef } from "react";
import { useNotepadStore } from "../store/useNotepadStore";

const EXIT_DURATION_MS = 300;

export function StudentTalkBlockedToast() {
  const [isWarning, setIsWarning] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const exitTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const notepadState = useNotepadStore((s) => s.state);

  useEffect(() => {
    if (notepadState === "CLOSED") {
      if (exitTimerRef.current) clearTimeout(exitTimerRef.current);
      setIsWarning(false);
      setIsExiting(false);
    }
  }, [notepadState]);

  const triggerDismiss = useCallback(() => {
    setIsExiting(true);
    exitTimerRef.current = setTimeout(() => {
      setIsWarning(false);
      setIsExiting(false);
    }, EXIT_DURATION_MS);
  }, []);

  useEffect(() => {
    const handleEvent = () => {
      if (exitTimerRef.current) clearTimeout(exitTimerRef.current);
      setIsExiting(false);
      setIsWarning(true);
    };

    window.addEventListener("notepad:student-talk-blocked", handleEvent);
    return () =>
      window.removeEventListener("notepad:student-talk-blocked", handleEvent);
  }, []);

  useEffect(
    () => () => {
      if (exitTimerRef.current) clearTimeout(exitTimerRef.current);
    },
    [],
  );

  const handleClose = useCallback(() => {
    triggerDismiss();
  }, [triggerDismiss]);

  const visible = isWarning || isExiting;

  if (!visible) return null;

  return (
    <div
      className="flex justify-center pointer-events-none w-full"
      style={{
        opacity: isExiting ? 0 : 1,
        transform: isExiting ? "translateY(-16px)" : "translateY(0)",
        transition: `opacity ${EXIT_DURATION_MS}ms ease-out, transform ${EXIT_DURATION_MS}ms ease-out`,
      }}
    >
      <div
        className="pointer-events-auto overflow-hidden rounded-[10px]"
        style={{
          background: "#FFF0D1",
          minWidth: 340,
        }}
      >
        {/* Main row */}
        <div className="flex items-center gap-3 px-5 py-[15px]">
          <img
            src="/assets/warning_alt.svg"
            alt="Warning"
            style={{ width: 22, height: 22, flexShrink: 0 }}
          />
          <span
            style={{
              fontFamily: "'Mulish', sans-serif",
              fontSize: 15,
              fontWeight: 700,
              color: "#1a1a1a",
              flex: 1,
              whiteSpace: "nowrap",
            }}
          >
            You can't talk to the tutor right now. Go back to the lesson to talk
          </span>
          <button
            onClick={handleClose}
            style={{
              fontFamily: "'Mulish', sans-serif",
              fontSize: 14,
              fontWeight: 700,
              color: "#1a1a1a",
              background: "#FFFFFF",
              border: "none",
              borderRadius: 8,
              padding: "7px 14px",
              cursor: "pointer",
              flexShrink: 0,
              whiteSpace: "nowrap",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
